import { render, staticRenderFns } from "./MtMaterialsModal.vue?vue&type=template&id=5d92a121&"
import script from "./MtMaterialsModal.vue?vue&type=script&lang=js&"
export * from "./MtMaterialsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports